import { createFileRoute } from '@tanstack/react-router';
import { ImportPage } from '../../components/import/ImportPage';
import { MathJaxProvider } from '../../components/rich-text';

export const Route = createFileRoute('/_admin/import')({
  validateSearch: (search): { batch?: string } =>
    typeof search.batch === 'string' && /^[0-9a-f-]{36}$/i.test(search.batch)
      ? { batch: search.batch }
      : {},
  component: ImportRoute,
});

function ImportRoute() {
  const { batch } = Route.useSearch();
  return (
    <MathJaxProvider>
      <ImportPage batchId={batch} />
    </MathJaxProvider>
  );
}
